import { SortDirection, TableSort } from "../tables/table";
import { ArrayStringFilterOperator } from "./advanced-filters/array-string-filter";
import { AdvancedFilterType } from "./advanced-filters/generic-advanced-filter-data";
import { AdvancedFilterData, DEFAULT_PAGE_SIZE, viewTypes } from "./views";

export enum TransfersSystemView {
  ALL = "all",
  NEEDS_FULFILLMENT = "needs-fulfillment",
  NEEDS_RECEIVING = "needs-receiving",
  COMPLETE = "complete",
}

export const TransferOrderStatus = {
  DRAFT: "DRAFT",
  UNFULFILLED: "UNFULFILLED",
  PARTIALLY_FULFILLED: "PARTIALLY_FULFILLED",
  FULFILLED: "FULFILLED",
  PARTIALLY_RECEIVED: "PARTIALLY_RECEIVED",
  COMPLETE: "COMPLETE",
} as const;
export type TransferOrderStatus =
  (typeof TransferOrderStatus)[keyof typeof TransferOrderStatus];

export const transferSortDefault: TableSort = {
  direction: SortDirection.DESC,
  key: "createdAt",
};

const getStatusFilter = (statuses: TransferOrderStatus[]) =>
  ({
    name: "status",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: statuses,
    operator: ArrayStringFilterOperator.ANY_OF,
  }) as AdvancedFilterData;

const defaultColumns = [
  { key: "transferNumber", width: 120, hidden: false },
  { key: "status", width: 150, hidden: false },
  { key: "originLocation", width: 180, hidden: false },
  { key: "destinationLocation", width: 180, hidden: false },
  { key: "skuCount", width: 80, hidden: false },
  { key: "totalItems", width: 100, hidden: false },
  { key: "createdAt", width: 150, hidden: false },
];

export const StaticTransferViews: Record<
  TransfersSystemView,
  viewTypes["transfers"]
> = {
  [TransfersSystemView.ALL]: {
    table: "transfers",
    name: TransfersSystemView.ALL,
    filters: [],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: transferSortDefault,
    position: 0,
    isNotEditable: true,
  },
  [TransfersSystemView.NEEDS_FULFILLMENT]: {
    table: "transfers",
    name: TransfersSystemView.NEEDS_FULFILLMENT,
    filters: [
      getStatusFilter([
        TransferOrderStatus.DRAFT,
        TransferOrderStatus.UNFULFILLED,
        TransferOrderStatus.PARTIALLY_FULFILLED,
      ]),
    ],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: transferSortDefault,
    position: 1,
  },
  [TransfersSystemView.NEEDS_RECEIVING]: {
    table: "transfers",
    name: TransfersSystemView.NEEDS_RECEIVING,
    filters: [
      getStatusFilter([
        TransferOrderStatus.FULFILLED,
        TransferOrderStatus.PARTIALLY_RECEIVED,
      ]),
    ],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: transferSortDefault,
    position: 2,
  },
  [TransfersSystemView.COMPLETE]: {
    table: "transfers",
    name: TransfersSystemView.COMPLETE,
    filters: [getStatusFilter([TransferOrderStatus.COMPLETE])],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: transferSortDefault,
    position: 3,
  },
};

export function friendlyTransferViewName(viewName: string): string {
  switch (viewName) {
    case TransfersSystemView.ALL:
      return "All";
    case TransfersSystemView.NEEDS_FULFILLMENT:
      return "Needs Fulfillment";
    case TransfersSystemView.NEEDS_RECEIVING:
      return "Needs Receiving";
    case TransfersSystemView.COMPLETE:
      return "Complete";
    default:
      return viewName;
  }
}
